define([
    'angular',
    'modules/core/core.module',
    'modules/access/access.module',
    'modules/upgrade/upgrade.module',
    'modules/template/template.module',
    'modules/dashboard/dashboard.module',
    'modules/seochecker/seochecker.module',
    'modules/seospider/seospider.module',
    'modules/pitchground/pitchground.module',
    //'modules/deals/deals.module',
    //'modules/seoeditor/seoeditor.module',
    'src/app/modules/writerassistant/writerassistant.module',
    'modules/keywordexplorer/keywordexplorer.module',
    'modules/keywordlistmanager/keywordlistmanager.module',
    'modules/project/project.module',
    'modules/leadgeneration/leadgeneration.module',
    //'modules/customer-offer/customer-offer.module',
    'modules/copymetrics/copymetrics.module',
    'modules/settings/settings.module',
    'modules/serpchecker/serpchecker.module',
    'modules/searchconsole/searchconsole.module',
    'modules/backlink-checker/backlink-checker.module',
    'modules/googleads/googleads.module',
    'modules/uisto/uisto.module',
], function (angular) {
    const __env = window.__env;

    function logWelcomeInConsole(__env) {
        console.log('' +
            '  ________  ___________  ______    \n' +
            ' /"       )("     _   ")/    " \\   \n' +
            '(:   \\___/  )__/  \\\\__/// ____  \\  \n' +
            ' \\___  \\       \\\\_ /  /  /    ) :) \n' +
            '  __/  \\\\      |.  | (: (____/ //  \n' +
            ' /" \\   :)     \\:  |  \\        /   \n' +
            '(_______/       \\__|   \\"_____/    \n');
        console.log('Welcome to SEO Tester Online ' + __env.stage + ' console!');
    }

    logWelcomeInConsole(__env);

    var app = angular.module('app', [
        'app.core',
        'app.uisto',
        'app.template',
        'app.dashboard',
        //'deals',
        //'app.seoeditor',
        'app.writerassistant',
        'app.serpchecker',
        'app.searchconsole',
        'app.seochecker',
        'app.seospider',
        'app.keywordexplorer',
        'app.keywordlistmanager',
        'app.project',
        'app.leadgeneration',
        //'customer-offer',
        'app.copymetrics',
        'app.settings',
        'app.backlinkchecker',
        'app.googleads',
        'pitchground',
        'access',
        'upgrade',
    ]);

    app.constant('__env', __env);

    app.factory('Cache', ['$cacheFactory', function ($cacheFactory) {
        return $cacheFactory('Cache', {
            capacity: 100
        });
    }]);

    app.run(['$state', '$rootScope', 'AuthService', 'UserService', 'TrackEventService', '$timeout', 'LanguageService', '__env',
        function ($state, $rootScope, AuthService, UserService, TrackEventService, $timeout, LanguageService, __env) {
            function isLocalhost() {
                const hostname = window.location.hostname;
                return hostname === 'localhost' || hostname === '127.0.0.1';
            }

            function pushUserOnTrackingSystem() {
                var user = AuthService.getSessionUser();
                if (!user) {
                    return;
                }

                AuthService
                    .me()
                    .then(function (user) {
                        if (!user) {
                            return;
                        }

                        AuthService.setSessionUser(user);
                        TrackEventService.push({
                            'userId': user.uuid
                        });
                        TrackEventService.push({
                            'email': user.email
                        });

                        if (user.jobTitle) {
                            TrackEventService.push({
                                'jobTitle': user.jobTitle
                            });
                        }

                        if (user.businessType) {
                            TrackEventService.push({
                                'businessType': user.businessType
                            });
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                    });
            }

            var host = window.location.hostname || 'suite.seotesteronline.com';
            var pathname = window.location.pathname || '';
            var vm = $rootScope;

            if (host.indexOf('seotesteronline') >= 0 && window.location.protocol === 'http:') {
                window.location = 'https:' + host + pathname;
            }

            $rootScope.session = {};
            $rootScope.isLoggedIn = {};

            /* Route skeleton of the keyword list manager. It stays on screen
               until a state really becomes active: the tool redirects from the
               landing to the list, and clearing it on the cancelled transition
               would flash the page the user is leaving back on screen. */
            var routeLoadingWatchdog = null;
            var projectSectionLoadingWatchdog = null;

            function showRouteLoading() {
                vm.keywordListLoading = true;
                if (routeLoadingWatchdog) {
                    $timeout.cancel(routeLoadingWatchdog);
                }
                /* Safety net: never leave the skeleton on screen forever. */
                routeLoadingWatchdog = $timeout(hideRouteLoading, 12000);
            }

            function hideRouteLoading() {
                if (routeLoadingWatchdog) {
                    $timeout.cancel(routeLoadingWatchdog);
                    routeLoadingWatchdog = null;
                }
                vm.keywordListLoading = false;
            }

            function showProjectSectionLoading() {
                $rootScope.projectSectionLoading = true;
                if (projectSectionLoadingWatchdog) {
                    $timeout.cancel(projectSectionLoadingWatchdog);
                }
                /* A cancelled route must never leave its skeleton over the app. */
                projectSectionLoadingWatchdog = $timeout(function () {
                    projectSectionLoadingWatchdog = null;
                    $rootScope.projectSectionLoading = false;
                }, 12000);
            }

            function hideProjectSectionLoading() {
                if (projectSectionLoadingWatchdog) {
                    $timeout.cancel(projectSectionLoadingWatchdog);
                    projectSectionLoadingWatchdog = null;
                }
                $rootScope.projectSectionLoading = false;
            }

            $rootScope.$on('$stateChangeStart',
                function (event, next, toParams, fromState) {
                    vm.isAuth = AuthService.isAuthenticated();
                    if (next.name.indexOf('app.project.detail.') === 0
                        && fromState.name.indexOf('app.project.detail.') === 0
                        && next.name !== fromState.name) {
                        showProjectSectionLoading();
                    }
                    var projectsOnly = next.name === 'app.welcome' || next.name.indexOf('app.project.') === 0 ||
                        next.name.indexOf('app.keywordlistmanager') === 0;

                    if (next.name.indexOf('app.keywordlistmanager') === 0) {
                        showRouteLoading();
                    } else {
                        hideRouteLoading();
                    }

                    if (next.name == "upgrade.choose-plan") {
                        $timeout(function () {
                            vm.bodyClassModifier = 'choosePlanPage';
                        }, 500);
                    } else {
                        vm.bodyClassModifier = null;
                    }

                    if (AuthService.isAuthenticated()) {
                        if (!projectsOnly) pushUserOnTrackingSystem();
                        (projectsOnly ? UserService.sessionInfo() : UserService.limits(true))
                            .then(function (res) {
                                if (res && res.data && res.data.workspace && res.data.workspace.id) {
                                    TrackEventService.push({
                                        'workspace': res.data.workspace.id
                                    });
                                }

                                var subscriptions = res.data.subscriptions || [];
                                var subscriptionsActive = [];
                                var subscriptionsTrial = [];
                                vm.subscriptionActive = false;
                                vm.subscriptionTrial = false;
                                subscriptions.forEach(function (subscription) {
                                    if (subscription.status === 'active') {
                                        subscriptionsActive.push(subscription);
                                    }
                                    if (subscription.status === 'trialing') {
                                        subscriptionsTrial.push(subscription);
                                    }
                                });

                                if (subscriptionsActive.length) {
                                    vm.subscriptionActive = true;

                                    if (res && res.data && res.data.mostImportantSub && res.data.mostImportantSub.alias) {
                                        TrackEventService.push({
                                            'accountType': res.data.mostImportantSub.alias
                                        });
                                        TrackEventService.push({
                                            'accountState': res.data.mostImportantSub.alias
                                        });
                                    }
                                    subscriptionsTrial = [];
                                } else if (subscriptionsTrial.length) {
                                    vm.subscriptionTrial = true;

                                    if (subscriptionsTrial &&
                                        subscriptionsTrial.length > 0 &&
                                        subscriptionsTrial[subscriptionsTrial.length - 1] &&
                                        subscriptionsTrial[subscriptionsTrial.length - 1].plans &&
                                        subscriptionsTrial[subscriptionsTrial.length - 1].plans[0] &&
                                        subscriptionsTrial[subscriptionsTrial.length - 1].plans[0].alias
                                    ) {
                                        TrackEventService.push({
                                            'accountType': subscriptionsTrial[subscriptionsTrial.length - 1].plans[0].alias + '-trial'
                                        });
                                        TrackEventService.push({
                                            'accountState': subscriptionsTrial[subscriptionsTrial.length - 1].plans[0].alias + '-trial'
                                        });
                                    }
                                } else {
                                    TrackEventService.push({
                                        'accountType': 'free'
                                    });
                                    TrackEventService.push({
                                        'accountState': 'free' + (res.data.canDoTrial ? '' : '-already-tried')
                                    });
                                    vm.isTrialing = res.data.canDoTrial;
                                }
                            })
                            .catch(function (err) {
                                console.log(err);
                            });
                    } else {
                        vm.isTrialing = true;
                        TrackEventService.push({
                            'accountType': 'not-logged-in'
                        });
                        TrackEventService.push({
                            'accountState': 'not-logged-in'
                        });
                    }

                    if (AuthService.isAuthenticated() && !projectsOnly) {
                        UserService.getSuggestedPlans(true);
                    }

                    $rootScope.previousState = fromState.name;
                    $rootScope.previousParams = $rootScope.toParams;

                    $rootScope.toParams = toParams;
                    $rootScope.currentState = next.name;

                    if (next.redirectTo) {
                        $state.go(next.redirectTo, toParams);
                    }

                    $rootScope.$broadcast('onRoutingChange');

                    if (next.access && next.access.restricted && !AuthService.isAuthenticated()) {
                        event.preventDefault();
                        $state.go('access.signin');
                    }
                });
            $rootScope.$on('$stateChangeSuccess', function (event, toState) {
                /* Traffic hands the overlay over to its own detailed skeleton
                   only after the component controller has been initialised. */
                if (!toState || toState.name !== 'app.project.detail.traffic') {
                    hideProjectSectionLoading();
                }
                hideRouteLoading();
            });
            $rootScope.$on('$stateChangeError', function () {
                hideProjectSectionLoading();
                hideRouteLoading();
            });
            /* No handler for $stateChangeCancel: a cancelled transition is
               normally the redirect inside the tool, and the state replacing it
               is already loading (its own $stateChangeStart fired). */
        }
    ]);

    //
    app.controller('AppController', ['$rootScope', 'CheckoutService', 'AuthService', '$state', '$scope', '$translate',
        '$cookies', '$location', '$timeout', 'SocketFactory', 'stAlertLimitService', 'BetaProgramService', 'LanguageService', '__env',
        function ($rootScope, CheckoutService, AuthService, $state, $scope, $translate, $cookies,
                  $location, $timeout, SocketFactory, stAlertLimitService, BetaProgramService, LanguageService, __env) {

            /**
             * Start Socket Connection
             */
            function initSocket() {
                console.log('Init Socket');
                var user = AuthService.getSessionUser();

                if (user && user.id) {
                    if (user.fromAdmin || __env.stage === 'local' || __env.stage === 'development') {
                        return;
                    }

                    SocketFactory.on('connect', function () {
                        console.log(' socket connected');
                        SocketFactory.emit('multi-session-login', {
                            userId: user.id,
                            session: AuthService.getSessionToken(),
                        });
                    });

                    var multiSessionEvent = false;
                    SocketFactory.on('multi-session-too-many-login', function () {
                        if (multiSessionEvent || user.fromAdmin || __env.stage === 'local' || __env.stage === 'development') {
                            return;
                        }

                        multiSessionEvent = true;
                        stAlertLimitService.open('auth-login', {
                            error: {
                                request: {
                                    alias: 'max-simultaneous-login',
                                }
                            },
                            canClose: false
                        })
                            .then(function () {
                                AuthService.logout();
                                $state.go('access.signin');
                            })

                        $timeout(function () {
                            AuthService.logout();
                        }, 500);

                        $timeout(function () {
                            multiSessionEvent = false;
                        }, 2000);
                    });
                }

                SocketFactory.on('search-result', function (data) {
                    $rootScope.$broadcast("socketSearchResult", data);
                });

                SocketFactory.on('gsc-keywords', function (data) {
                    $rootScope.$broadcast("socketGscKeywords", data);
                });
            }

            $rootScope.allLanguages = $translate.getAvailableLanguageKeys();

            function applyDocumentDirection(langKey) {
                var rtlLanguages = ['ar', 'fa', 'he', 'ur'];
                var language = String(langKey || '').split('-')[0].toLowerCase();
                var isRtl = rtlLanguages.indexOf(language) !== -1;
                document.documentElement.lang = language || 'en';
                document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
                document.body.classList.toggle('st-rtl', isRtl);
            }

            applyDocumentDirection(LanguageService.getCodeAndCountrySaveOnStorage() || __env.preferredLanguage);

            $rootScope.setLang = function (langKey) {
                $scope.lang = langKey;
                if (!langKey) {
                    return;
                }

                LanguageService.setCodeAndCountryOnStorage(langKey);
                applyDocumentDirection(langKey);
                try {
                    var languageUrl = new URL($window.location.href);
                    languageUrl.searchParams.set('lang', langKey);
                    $window.history.replaceState(
                        $window.history.state,
                        '',
                        languageUrl.pathname + languageUrl.search + languageUrl.hash
                    );
                } catch (error) {
                    // Older browsers can still change the language without updating the URL.
                }

                $translate.use(langKey)
                    .then(function () {
                        $rootScope.$broadcast('languageChanged', langKey);
                    });
            };

            var storeferral = $location.search().storeferral;
            if (storeferral) {
                $cookies.put('storeferral', storeferral, {
                    domain: 'seotesteronline.com',
                    expires: new Date(new Date().setDate(new Date().getDate() + 60))
                });
            }

            if (!window.location.hostname.includes('localhost') && !window.location.hostname.includes('127.0.0.1')) {
                initSocket();
            }

            $scope.$state = $state;
            $scope.source = $state.current.name.replace('app.', '')
                .replace(/\..*/gi, '')
                .toLowerCase();

            $scope.$watchCollection('$state', function () {
                if ($state.current.name) {
                    $scope.source = $state.current.name.replace('app.', '')
                        .replace(/\..*/gi, '')
                        .toLowerCase();
                } else {
                    $scope.source = 'not-specified';
                }
            });
            $translate('currentLangCode')
                .then(function (lang) {
                    $scope.lang = lang;
                });
        }
    ]);

    app.config(['FacebookProvider', function (FacebookProvider) {
        // Set your appId through the setAppId method or
        // use the shortcut in the initialize method directly.
        FacebookProvider.setLocale('it_IT');
        FacebookProvider.init('457790181098375');
    }]);

    // Config Module Translate & Partial Loader
    app.config(['$translateProvider', '$translatePartialLoaderProvider', '__env',
        function ($translateProvider, $translatePartialLoaderProvider, __env) {
            try {
                $translateProvider.useLoader('$translatePartialLoader', {
                    urlTemplate: './app/locales/{lang}/{part}.json'
                });

                // Add all File Json we need
                var locales = __env.locales.split(",");
                for (var i = 0; i < locales.length; i++) {
                    $translatePartialLoaderProvider.addPart(locales[i]);
                }

                // Register all languages we hase set on env
                var languages = __env.languages.split(',').map(function (language) {
                    return language.trim();
                }).filter(Boolean);
                $translateProvider.registerAvailableLanguageKeys(languages);

                function normalizeLanguage(value) {
                    var language = String(value || '').replace(/_/g, '-').toLowerCase();
                    if (!language) {
                        return null;
                    }
                    var exact = languages.find(function (item) {
                        return item.toLowerCase() === language;
                    });
                    if (exact) {
                        return exact;
                    }
                    var base = language.split('-')[0];
                    return languages.find(function (item) {
                        return item.split('-')[0].toLowerCase() === base;
                    }) || null;
                }

                // A language received from the marketing site must win over the
                // browser locale, but later user choices are stored and reused.
                var storedLanguage = null;
                try {
                    storedLanguage = localStorage.getItem('NG_TRANSLATE_LANG_KEY');
                } catch (error) {
                    storedLanguage = null;
                }
                $translateProvider.preferredLanguage(
                    normalizeLanguage(storedLanguage)
                    || normalizeLanguage(navigator.language)
                    || normalizeLanguage(__env.preferredLanguage)
                    || languages[0]
                );

                // FallBack: in case don't exist language set it for Strange Casuistry
                $translateProvider.fallbackLanguage(__env.preferredLanguage);

                // Secure strategy
                $translateProvider.useSanitizeValueStrategy('escapeParameters');
                $translateProvider.forceAsyncReload(true);

                // Save language code in LocalStorage
                // and if it enable into Cookie
                $translateProvider.useLocalStorage();
            } catch (e) {
                console.log("Error during locale initializiation");
                console.log(e);
            }
        }
    ]);

    app.config(['$compileProvider', function ($compileProvider) {
        $compileProvider.debugInfoEnabled(false);
    }]);

    return app;
});
